import muze from '../img/portImages/muze.png'
import uangku from '../img/portImages/uangku.png'
import simply from '../img/portImages/simply.png'
import chat from '../img/portImages/chat.png'
import weather from '../img/portImages/weather.png'
import crypto from '../img/portImages/crypto.png'

const portfolios = [
    {
        id: 1,
        image: muze,
        link: 'muze',
        title: 'Muze - Music App',
        text: 'Responsive website Music App made with reactJS'
    },
    {
        id: 2,
        image: uangku,
        link: 'uangku',
        title: 'Uangku - Money Exchange',
        text: 'Money Landing page with responsive to mobile'
    },
    {
        id: 3,
        image: simply,
        link: 'simply',
        title: 'Simply - Shopping Website',
        text: 'Online shop App with responsive and scroll smooth'
    },
    {
        id: 4,
        image: chat,
        link: 'talkz',
        title: 'Talkz - Chat App using API',
        text: 'Chat app using chat engine API, talkz now!'
    },
    {
        id: 5,
        image: weather,
        link: 'weather',
        title: 'Weather Forecast App',
        text: 'Simple app with presition and acurate weather'
    },
    {
        id: 6,
        image: crypto,
        link: 'crypto',
        title: 'Cryptoland - Crypto News',
        text: 'An app to see information about crypto'
    }
]

export default portfolios;